import { Breadcrumbs, Button } from "@mantine/core";

const CustomBreadcrumb = ({ items, click, activeIndex }) => {
  return (
    <Breadcrumbs separator="→">
      {items &&
        items.map((item, index) => (
          <Button
            disabled={index >= activeIndex && index !== 0}
            variant="outline"
            onClick={(e) => click(e, item.href, item.index)}
            key={index}
            compact>
            {item.title}
          </Button>
        ))}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumb;
